<template>
  <div class="my_form">
    <el-dialog
      :title="record.createUserId ? '详情' : '新建文件夹'"
      :visible.sync="visible"
      width="500px"
      top='25vh'
      :before-close="onClose"
    >
     <div v-if="record.createUserId">
        <el-row>
          <el-col :span="24">
             文件名称: {{record.name}}
          </el-col>
          <el-col style="margin-top:10px;" :span="24">
            创建人:  {{record.createUserId}}
          </el-col>
          <el-col style="margin-top:10px;" :span="24">
            最近修改人  {{record.updateUserId}}
          </el-col>
          <el-col style="margin-top:10px;" :span="24">
             修改时间 {{record.updateTime}}
          </el-col>
        </el-row>
     </div>
     <div v-else>
        <el-form :model="form" ref="form" inline label-width="100px">
          <el-row>
            <el-col :span="24">
              <el-form-item label="文件夹名称:" prop="name">
                <el-input v-model="form.name" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
     </div>
     <span slot="footer" class="dialog-footer">
       <el-button v-if="!record.createUserId" size="small" type="primary" @click="handleSubmit">确 定</el-button>
       <el-button v-else type="danger"  size="small"  @click="handleDelete">删 除</el-button>
     </span>
    </el-dialog>
  </div>
</template>

<script>
// import { initUserInfo } from '@/store/utils';
import { CloudDisk } from '@/api/knowledge'; //
export default {
  props: {
    visible: {
      type: Boolean,
      required: false
    },
    id: {
      type: [String, Number],
      default: null
    },
    record: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      form: {
        name: ''
      },
      winList: [] // 中标项目列表
    };
  },
  watch: {
    visible (val) {
      if (val) {
        this.form = {
          name: ''
        }
      }
    }
  },
  created () {
  },
  methods: {
    handleSubmit () {
      this.form.pid = this.id
      this.form.type = 'FOLDER'
      // this.form.createUserId = initUserInfo().userId
      const func = CloudDisk.createFile
      func(this, { cloudDiskDto: this.form}).then(res => {
        this.$message({
          message: '添加成功',
          type: 'success'
        });
        this.$emit('submitForm');
        this.onClose()
      }).catch(() => {
        this.$message.error('添加失败');
      })
    },
    handleDelete () {
      const func = CloudDisk.deleteFile
      func(this, { id: this.record.id}).then(res => {
        this.$message({
          message: '删除成功',
          type: 'success'
        });
        this.$emit('submitForm');
        this.onClose()
      }).catch(() => {
        this.$message.error('删除失败');
      })
    },
    onClose () {
      this.$emit('update:visible', false);
    },
    onDialogClose () {
      // 还好保留一个遮罩，直接移除
      const tag = document.querySelector('.checkList .v-modal');
      if (tag) tag.remove();
    }
  }
};
</script>

<style lang="scss" scoped>
.dialog-footer{
  text-align: center;
}
</style>
